var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row items-center justify-end q-gutter-sm"},[_c('action-show-button',{attrs:{"url":_vm.showPageLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }